import { createStore } from "@stencil/store";

export interface ShopInformation {
  numberOfShoppingItems: number;
  wishlistItemsNumber: number;
  subTotal: string;
}

export interface ShopStateStoreTypes {
  shopInformation: ShopInformation;
}

export const shopStoreDefaultData = {
  shopInformation: {
    numberOfShoppingItems: 0,
    wishlistItemsNumber: 0,
    subTotal: "0",
  },
};

export const shopStateStore =
  createStore<ShopStateStoreTypes>(shopStoreDefaultData);
